const brandMainColor = window._env_.BRAND_COLOR_HEX;
export function getDynamicBackgroundColor(options) {
  console.log(`${brandMainColor}`);
  return {
    background: `${brandMainColor}`,
  }
}

export function getDynamicBackgroundColorAttribute(options) {
  console.log(`${brandMainColor}`);
  return {
    backgroundColor: `${brandMainColor}`,
  }
}

export function getHexColor(options){
  return `${brandMainColor}`;
}

export function getDynamicTextColor(options) {
  return {
    color: `${brandMainColor}`,
  }
}


// WEBPACK FOOTER //
// ./src/components/common/color_utils.js